export const shadows = {
  shadow100: `0px 6px 6px 0px var(--shadowColor)`,
  shadow200: `0px 12px 12px 0px var(--shadowColor)`,
  shadow300: `0px 24px 24px 0px var(--shadowColor)`,
  shadow400: `0px 42px 42px 0px var(--shadowColor)`,
} as const;

export type Shadows = Record<keyof typeof shadows, string> & { raw: typeof shadows };
